/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Moderationcolumnmessage2Inputs */

const en_moderationcolumnmessage2 = /** @type {(inputs: Moderationcolumnmessage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message`)
};

const de_moderationcolumnmessage2 = /** @type {(inputs: Moderationcolumnmessage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachricht`)
};

/**
* | output |
* | --- |
* | "Message" |
*
* @param {Moderationcolumnmessage2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const moderationcolumnmessage2 = /** @type {((inputs?: Moderationcolumnmessage2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Moderationcolumnmessage2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_moderationcolumnmessage2(inputs)
	return de_moderationcolumnmessage2(inputs)
});
export { moderationcolumnmessage2 as "moderationColumnMessage" }